/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const DishCategoryDto = {
    Dish: 'DISH',
    Drink: 'DRINK',
    Dessert: 'DESSERT',
} as const;

export type DishCategoryDto = typeof DishCategoryDto[keyof typeof DishCategoryDto];



